import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Leadership from './components/Leadership';
import Projects from './components/Projects';
import Education from './components/Education';
import Contact from './components/Contact';
import Nav from './components/Nav';
import './App.css';

function App() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Leadership />
        <Projects />
        <Education />
        <Contact />
      </main>
    </>
  );
}

export default App;
